"use client";

import type { Variant } from "@raumagarn/formatters";
import { clsx } from "@trydig/ui";
import type { Size } from "~/components/ui/ToolPDPContainer/ToolPDPContainer";
import { InlineContent } from "~/features/products/ProductCard/parts/InlineContent";
import styles from "./ToolSizePicker.module.css";

export const ToolSizePicker = ({
	sizes,
	selectedSize,
	setSelectedSize,
}: {
	sizes: Size[] | undefined;
	selectedSize: Size | undefined;
	setSelectedSize: (size: Size | undefined) => void;
}) => {
	return (
		<div className={styles.box}>
			<h2>Størrelse</h2>
			{selectedSize && (
				<InlineContent>
					<strong>Lengde</strong>
					<span>{selectedSize.name}</span>
				</InlineContent>
			)}
			<div className={styles.sizes}>
				{sizes?.map((size) => {
					return (
						<button
							key={size.id}
							className={clsx(styles.size, size === selectedSize && styles.selected)}
							disabled={!size.stock}
							onClick={() =>
								selectedSize === size ? setSelectedSize(undefined) : setSelectedSize(size)
							}
						>
							{size.name}
						</button>
					);
				})}
			</div>
		</div>
	);
};

interface VariantPickerProps {
	variants: Variant[];
	selectedVariant?: Variant;
	setSelectedVariant: (variant: Variant | undefined) => void;
}

export const ToolVariantPicker = ({
	variants,
	selectedVariant,
	setSelectedVariant,
}: VariantPickerProps) => {
	return (
		<div className={styles.box}>
			<h2>Størrelse</h2>
			{selectedVariant && (
				<InlineContent>
					<strong>Størrelse</strong>
					<span>{selectedVariant.length}</span>
				</InlineContent>
			)}
			<div className={styles.sizes}>
				{variants?.map((variant) => {
					const size = variant.items?.[0];
					return (
						<button
							key={variant.displayItemId}
							className={clsx(styles.size, variant === selectedVariant && styles.selected)}
							disabled={!size?.stock || size.stock === "no"}
							onClick={() =>
								selectedVariant === variant
									? setSelectedVariant(undefined)
									: setSelectedVariant(variant)
							}
						>
							{variant.length}
						</button>
					);
				})}
			</div>
		</div>
	);
};
